import { Nav, NavItem } from 'react-bootstrap';
import styled from 'styled-components';

export const NavWrapper = styled(Nav)`
    // border-bottom: 0.5px solid #337ab7;

    & > li {
        //height: 52px;
    }

    & > li > a {
        font-size: 14px;
        font-weight: 500;
        // background-color: #337ab7;
        // color: white;
        // width: 160px;
        text-align: center;
        // line-height: 15px;
        padding: 5px 15px;
        height: 100%;
        display: flex;
        justify-content: center;
    }

    & > li > a:hover {
        background-color: #a0c5e5;
        color: black;
    }

    & > li > a.action {
        background-color: white;
        color: black;
    }

    & > li.active > a {
        background-color: #337ab7;
        color: white;
        // font-size: 14px;
        // line-height: 15px;
        // padding: 5px 7.5px;
    }

    @media (max-width: 1823px) {
        & > li > a,
        & > li.active > a {
            // font-size: 12px;
            min-width: 120px;
        }
    }
`;

const ArApNav: React.FunctionComponent<{ href: string }> = (props) => {
    return (
        <NavWrapper bsStyle="tabs" activeHref={props.href}>
            <NavItem href='/admin/report/accounts-receivable'>
                NKR AR Aging
            </NavItem>
            <NavItem href="/admin/report/accounts-payable">
                NKR AP - CCB Aging
            </NavItem>
            <NavItem href="/admin/report/accounts-payable-payment">
                NKR AP – Payment
            </NavItem>
            <NavItem href="/admin/report/accounts-payable-opo">
                NKR AP - OPO Aging
            </NavItem>
            <NavItem href="/admin/report/accounts-payable-opo-payment">
                NKR AP – OPO Payment
            </NavItem>
        </NavWrapper>
    );
}

export default ArApNav;